import React from 'react';
import { Checkbox, Segmented, Tooltip } from 'antd';
import IntegrationIcon from 'components/Selects/IntegrationIcon';

const StoreSwitcher = ({
  disableSelectAll,
  allSelected,
  selectAllChanged,
  selectedApp,
  disableStoreSwitch,
  handleIntegrationChange,
  options,
}) => {
  return (
    <div className='flex items-center justify-between gap-2'>
      {!disableSelectAll && (
        <Tooltip
          placement='right'
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          title={allSelected ? 'Clear All' : `Select All ${options.length}`}
        >
          <Checkbox
            checked={allSelected}
            onChange={selectAllChanged}
            className='text-xs font-normal'
          />
        </Tooltip>
      )}
      {!disableStoreSwitch && (
        <Segmented
          value={selectedApp}
          onChange={handleIntegrationChange}
          options={[
            {
              label: <span className='text-xs'>All</span>,
              value: 'all',
            },
            {
              label: <IntegrationIcon integration='shopify' />,
              value: 'shopify',
            },
            {
              label: <IntegrationIcon integration='woocommerce' />,
              value: 'woocommerce',
            },
            {
              label: <IntegrationIcon integration='clickfunnels' />,
              value: 'clickfunnels',
            },
            {
              label: <IntegrationIcon integration='hubspot' />,
              value: 'HubSpot',
            },
          ]}
        />
      )}
    </div>
  );
};

export default StoreSwitcher;
